 <template>
    <el-dialog :visible.sync="visible" width="925px" append-to-body title="编辑描述" destroy-on-close :close-on-click-modal="false" :close-on-press-escape="false" :before-close="Close">
        <froala-editor v-model="form.describe" :heightMax="heightMax" v-if="visible" />
        <span slot="footer">
            <el-button size="mini" @click="Close()">取 消</el-button>
            <el-button size="mini" type="primary" @click="SubmitForm()" :loading="$store.state.loading">确 定</el-button>
        </span>
    </el-dialog>
</template>
<script>
export default {
    data () {
        return {
            visible: false,
            heightMax: 100,
            formError: {},
            form: {
                id: null,
                describe: null
            }
        }
    },
    watch: {
        '$el.offsetHeight': {
            handler() {
                this.heightMax = document.documentElement.offsetHeight * 0.6
            },
            immediate: true
        }
    },
    methods: {
                Open (form)
        {
            if (form.id)
            {
                this.form.id = form.id
                this.form.describe = form.describe
                this.visible = true
            }
        },
                Close() {
            this.visible = false
        },
                SubmitForm() {
            this.formError = {}
                        this.$http.post('/9api/crm/contract/update-describe', this.form).then(rps => {
                                if (rps.data.state == 'error') {
                    this.formError = rps.data.body
                }
                                if (rps.data.state == 'success') {
                    this.$emit('onChange', rps.data.body)
                    this.Close()
                }
            })
        }
    }  
}
</script>